<template>
  <div class="builds-module-root">
    <ba-header :activeModule="activeModule"></ba-header>

    <div class="builds-module__content main-content">

        <h2 class="u-pl4 u-mt2 c-heading__page">{{activeModule}}</h2>

        <div v-if="mode === 'mobile' && livePreviewAvailable" class="u-pl4 u-mb4">
          <h4 class="c-heading__section u-mb2">Live preview</h4>
          <p class="u-mb2 u-text--sm">
            Always current -- reflects live branding and settings immediately, no build to trigger.
          </p>
          <ba-build-preview :url="livePreviewUrl"></ba-build-preview>
        </div>

        <h4 class="u-pl4 u-mb2 c-heading__section" v-if="mode === 'mobile' && livePreviewAvailable">Native app builds</h4>
        <router-link :to="{name: 'new-build', query: {mode: mode}}" @click="$event.preventDefault()">
          <el-button type="success" class="u-ml4" icon="el-icon-plus" >New build</el-button>
        </router-link>
        <ba-build-list :mode="mode"></ba-build-list>
    </div>
  </div>
</template>

<script>
import BaBuildList from '@/modules/builds/build-list.component.vue'
import BaBuildPreview from '@/modules/builds/build-preview.component.vue'
import axios from 'axios'
import config from '@/config'

export default {
  components: {'ba-build-list': BaBuildList, 'ba-build-preview': BaBuildPreview},
  data () {
    return {
      livePreviewAvailable: false,
    }
  },
  computed: {
    mode () {
      return this.$route.query.mode
    },
    activeModule () {
      return this.mode === 'desktop' ? 'Web Builds' : 'Mobile Builds'
    },
    companyId () {
      return this.$route.params.companyId
    },
    livePreviewUrl () {
      return `${config.url}/company/${this.companyId}/mobile-preview/?token=${localStorage.carrierToken}`
    },
  },
  watch: {
    // Legacy (pre-EKS) briteapps-admin backends have no mobile-preview route: only show
    // the panel once the backend actually serves it, instead of framing a 404.
    livePreviewUrl: {
      immediate: true,
      handler (url) {
        this.livePreviewAvailable = false
        if (this.mode !== 'mobile') return
        axios.get(url).then(() => { this.livePreviewAvailable = true }).catch(() => {})
      },
    },
  },
  methods: {

  },
}
</script>
<style scoped lang="scss">
  .builds-module__content {
    padding-top: 3rem;
  }
</style>
